<template>
	<div id="wlmMachine" v-if="Object.keys(installApplication).length && machineDialogVisible">
		<el-dialog
			v-if="!notDialog"
			v-dialogDrag
			title="性能成分信息"
			custom-class="machine-dialog"
			:visible.sync="machineDialogVisible"
			:before-close="close"
			width="1100px"
			top="0"
			:close-on-click-modal="true"
			:close-on-press-escape="true"
		>
			<machine-panels
				ref="panels"
				:install-application="installApplication"
				:install-app-obj="installAppObj"
				:calculate-result-value="calculateResultValue"
				:yield-point="yieldPoint"
				:thread-stress-area="threadStressArea"
				:nominal-value="nominalValue"
				:chemical-component-list="chemicalComponentList"
				:mechanical-properties-list="mechanicalPropertiesList"
				:application-desc-html="applicationDescHtml"
				:is-show-machine-properties="isShowMachineProperties"
			/>
		</el-dialog>
		<div v-else class="machine-dialog machine-dialog--inline">
			<machine-panels
				ref="panels"
				:install-application="installApplication"
				:install-app-obj="installAppObj"
				:calculate-result-value="calculateResultValue"
				:yield-point="yieldPoint"
				:thread-stress-area="threadStressArea"
				:nominal-value="nominalValue"
				:chemical-component-list="chemicalComponentList"
				:mechanical-properties-list="mechanicalPropertiesList"
				:application-desc-html="applicationDescHtml"
				:is-show-machine-properties="isShowMachineProperties"
			/>
		</div>
	</div>
</template>

<script>
import * as machine from '@/api/machine/index'
import echarts from 'echarts'
import Md5 from 'js-md5'
import { filterParams } from '@/filters'
import MachinePanels from './machine-panels.vue'

export default {
	name: 'wlm-machine',
	components: { MachinePanels },
	props: {
		params: {
			// entranceType  11 工业百科列表 21 我的产品列表 22 我的产品详情 31 图纸草稿列表 32 图纸草稿详情
			// gbComponentId  当entranceType值为21或22时需传 默认无需传
			// nonStdId  当entranceType值为31或32时需传 默认无需传
			type: Object,
			default: {}
		},
		checkBigId: {
			type: [Number, String],
			default: '' // 默认设置1螺栓
		},
		notDialog: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			machineDialogVisible: false,
			installApplication: {}, //应用安装
			chemicalComponentList: [], //化学成分
			mechanicalPropertiesList: [], //机械性能
			threadStressArea: {}, // 螺纹应力截面积
			applicationDescHtml: '', //描述文本
			yieldPoint: '', //屈服点
			nominalValue: '', // 螺栓的公称直径
			installAppObj: {
				minRub: '',
				maxRub: '',
				minTorque: '',
				maxTorque: '',
				preload: '' //预紧力系数
			},
			echartsOption: {
				color: ['#2F5D8A', '#4A90C8', '#7BA3C9', '#E8A317', '#A0AEC0', '#5B7C99', '#8FA6BC'],
				series: [{
					type: 'pie',
					radius: ['36%', '58%'],
					center: ['50%', '50%'],
					data: [],
					itemStyle: {
						normal: {
							label: { show: true, formatter: '{b}', color: '#4A5562', fontSize: 11 },
							labelLine: { length: 10, length2: 8 }
						}
					}
				}]
			},
			privateKey: 'DevX3QIqik6mHmyuw',
			machineApiList: [ // 机械性能api
				'getMachinePropertiesParams',
				'getMachinePropertiesForFree',
				'getMachinePropertiesForFreeBaike'
			],
			asChartInstance: null,
			chemChartInstance: null
		}
	},
	computed: {
		isShowMachineProperties() { //当前选中大类的id
			// 1  73  306  315 螺栓   螺柱  螺钉  组合件
			// 获取列表大类id要传0，多个判断
			if (this.checkBigId == 1 || this.checkBigId == 0 || this.checkBigId == 73 || this.checkBigId == 306 || this.checkBigId == 315) {
				return true
			} else {
				return false
			}
		},
		calculateResultValue() {
			// 计算规则 = 预紧力系数（preload） * 屈服点（yieldPoint） * 螺纹应力截面积（stressArea） / 1000 * 螺栓的公称直径（nominalValue） * 扭矩系数（minTorque || maxTorque）
			var minVal = (this.installAppObj.preload * this.yieldPoint * this.threadStressArea.stressArea / 1000 * this.nominalValue * this.installAppObj.minTorque).toFixed(2)
			var maxVal = (this.installAppObj.preload * this.yieldPoint * this.threadStressArea.stressArea / 1000 * this.nominalValue * this.installAppObj.maxTorque).toFixed(2)
			return minVal + '-' + maxVal
		}
	},
	methods: {
		_getMachinePropertiesParams() {
			// 初始化安装应用参数
			this.installAppObj.preload = ''
			this.installAppObj.minTorque = ''
			this.installAppObj.maxTorque = ''

			this.machineDialogVisible = true
			var machineParamsObj = {
				entranceType: this.params.entranceType || '',
				gbComponentId: this.params.gbComponentId || '',
				materialId: this.params.materialId || '',
				nominalId: this.params.nominalId || '',
				nonStdId: this.params.nonStdId || '',
				standardId: this.params.standardId || '',
				strengthId: this.params.strengthId || '',
				surfaceId: this.params.surfaceId || '',
				timestamp: new Date().getTime(),
				toothTypeId: this.params.toothTypeId
			}
			if (this.params.gbComponentId > 0) { //当有componentId时，只需要传以下参数
				machineParamsObj = {
					entranceType: this.params.entranceType || '',
					gbComponentId: this.params.gbComponentId || '',
					timestamp: new Date().getTime()
				}
			}
			var signStr = ''
			for (var i in machineParamsObj) {
				signStr += i + '=' + machineParamsObj[i] + '&'
			}
			signStr = signStr.substring(0, signStr.length - 1) + this.privateKey
			machineParamsObj.sign = Md5(signStr)

			var apiIndex = 1
			machine[this.machineApiList[apiIndex]](filterParams(machineParamsObj)).then(res => {
				if (res.data.status != 10001) {
					this.installApplication = res.data.installApplication //应用安装
					this.chemicalComponentList = res.data.chemicalComponentList //化学成分
					this.mechanicalPropertiesList = res.data.mechanicalPropertiesList //机械性能
					this.threadStressArea = res.data.threadStressArea // 螺纹应力截面积
					this.applicationDescHtml = res.data.applicationDescHtml //描述文本
					this.yieldPoint = res.data.yieldPoint //屈服点
					this.nominalValue = res.data.nominalValue // 螺栓的公称直径

					this.echartsOption.series[0].data = []
					this.chemicalComponentList.forEach(item => {
						if (item.value.indexOf('-') != -1) {
							var name = item.name += item.value
							var val = item.value.substring(0, item.value.indexOf('-'))
							this.echartsOption.series[0].data.push({ name: name, value: val })
						} else {
							var name = item.name += item.value
							this.echartsOption.series[0].data.push({ name: name, value: item.value.replace(/(\≤|\=|\<|\>|\≥|\%|)/gi, '') })
						}
					})
					this.$nextTick(() => {
						if (this.chemicalComponentList.length) this.initChemEchart()
						if (Object.keys(this.threadStressArea).length) this.initAsEchart()
					})
				} else {
					this.$message.error(res.data.message || '获取参数失败')
					this.machineDialogVisible = false
				}
			}).catch(err => {
				this.$message.error('网络错误')
				this.machineDialogVisible = false
			})
		},
		getPanelRefs() {
			const panels = this.$refs.panels
			return panels ? panels.$refs : {}
		},
		buildAsOption() {
			const val = Number(this.threadStressArea.stressArea) || 0
			const display = val.toFixed(2)
			const visualMax = Math.max(val * 1.25, val + 10, 1)
			return {
				series: [{
					type: 'pie',
					radius: ['62%', '82%'],
					silent: true,
					label: { show: false },
					data: [
						{ value: val, itemStyle: { color: '#2F5D8A' } },
						{ value: Math.max(visualMax - val, 0.01), itemStyle: { color: '#E5E9EE' }, tooltip: { show: false } }
					]
				}],
				title: {
					text: display,
					subtext: 'mm²',
					left: 'center',
					top: '36%',
					textStyle: { fontSize: 16, fontWeight: 700, color: '#1B2430' },
					subtextStyle: { fontSize: 11, color: '#6B7785' }
				}
			}
		},
		initAsEchart() {
			const dom = this.getPanelRefs().asEchartsDom
			if (!dom || !Object.keys(this.threadStressArea).length) return
			if (this.asChartInstance) {
				this.asChartInstance.dispose()
				this.asChartInstance = null
			}
			this.asChartInstance = echarts.init(dom)
			this.asChartInstance.setOption(this.buildAsOption(), true)
			this.$nextTick(() => {
				if (this.asChartInstance) this.asChartInstance.resize()
			})
		},
		initChemEchart() {
			const dom = this.getPanelRefs().echartsDom
			if (!dom || !this.chemicalComponentList.length) return
			if (this.chemChartInstance) {
				this.chemChartInstance.dispose()
				this.chemChartInstance = null
			}
			this.chemChartInstance = echarts.init(dom)
			this.chemChartInstance.setOption(this.echartsOption, true)
			this.$nextTick(() => {
				if (this.chemChartInstance) this.chemChartInstance.resize()
			})
		},
		disposeChartInstances() {
			if (this.asChartInstance) {
				this.asChartInstance.dispose()
				this.asChartInstance = null
			}
			if (this.chemChartInstance) {
				this.chemChartInstance.dispose()
				this.chemChartInstance = null
			}
		},
		open() {
			this.machineDialogVisible = true
		},
		close() {
			this.disposeChartInstances()
			this.machineDialogVisible = false
		}
	},
	beforeDestroy() {
		this.disposeChartInstances()
	}
}
</script>

<style lang="scss">
	#wlmMachine {
		.el-dialog__wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.machine-dialog {
			width: min(1100px, 92vw) !important;
			margin: 0 auto !important;
			max-height: 90vh;
			display: flex;
			flex-direction: column;

			&.machine-dialog--inline {
				width: 100% !important;
				margin: 0 !important;
				max-height: none;
				display: block;
			}

			.machine-content {
				color: #333;
				max-height: calc(90vh - 76px);
				overflow-y: auto;
				background: #F0F2F5;
				margin: -16px -24px;
				padding: 16px 24px;
			}

			&.machine-dialog--inline .machine-content {
				margin: 0;
				max-height: none;
			}

			.mp-section {
				background: #fff;
				border: 1px solid #D5D9DE;
				border-radius: 6px;
				padding: 14px 16px;
				margin-bottom: 12px;

				&__head {
					display: flex;
					align-items: center;
					gap: 10px;
					margin-bottom: 12px;

					&::before {
						content: '';
						width: 4px;
						height: 18px;
						background: #2F5D8A;
						border-radius: 2px;
						flex-shrink: 0;
					}
				}

				&__en {
					font-size: 10px;
					letter-spacing: 1.5px;
					color: #6B7785;
					text-transform: uppercase;
					line-height: 1.2;
				}

				&__zh {
					font-size: 14px;
					font-weight: 600;
					color: #1B2430;
					line-height: 1.3;
				}

				&__extra { margin-left: auto; font-size: 11px; color: #6B7785; }
				&__tag {
					margin-left: auto; font-size: 11px; padding: 2px 8px;
					background: #E8F0F7; color: #2F5D8A; border-radius: 3px;
				}
			}

			.mp-mech {
				display: flex; gap: 16px; align-items: stretch;
				&__sketch {
					width: 88px; flex-shrink: 0; border: 1px dashed #2F5D8A; border-radius: 4px;
					background: #F7FAFC; display: flex; align-items: center; justify-content: center;
				}
				&__list { flex: 1; margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 6px; }
				&__row {
					display: flex; align-items: center; padding: 8px 12px;
					background: #F7FAFC; border-left: 3px solid #2F5D8A; border-radius: 0 4px 4px 0;
					&.is-accent { background: #FFF8E8; border-left-color: #E8A317; }
				}
				&__name { flex: 1; font-size: 13px; color: #4A5562; }
				&__val { font-size: 15px; font-weight: 700; color: #1B2430; font-variant-numeric: tabular-nums; }
			}

			.mp-chem__chart { width: 100%; height: 300px; }

			.mp-torque {
				display: flex;
				gap: 12px;
				align-items: stretch;

				&__side {
					flex: 1;
					display: flex;
					flex-direction: column;
					gap: 12px;
					min-width: 0;
				}
			}
			.mp-calc {
				flex: 0 0 42%;
				background: #1B2430;
				border-radius: 6px;
				padding: 16px;
				color: #fff;

				&__hint { font-size: 12px; color: #9AA5B1; margin-bottom: 14px; }
				&__field { margin-bottom: 12px;
					label { display: block; font-size: 11px; color: #9AA5B1; margin-bottom: 6px; }
				}
				&__row { display: flex; align-items: center; gap: 8px; }
				&__aside { font-size: 11px; color: #9AA5B1; }
				&__dash { color: #6B7785; }
				&__select {
					flex: 1;
					.el-input__inner {
						background: rgba(255,255,255,.12);
						border: none;
						color: #fff;
						padding: 0 10px;
					}
					.el-input__suffix { color: #fff; }
					&--sm { flex: 0 0 72px; width: 72px; }
				}
				&__result {
					border-top: 1px solid rgba(255,255,255,.15);
					padding-top: 14px;
					label { display: block; font-size: 11px; color: #9AA5B1; margin-bottom: 6px; }
				}
				&__torque { display: flex; align-items: baseline; gap: 8px; }
				&__value {
					font-size: 28px;
					font-weight: 700;
					color: #E8A317;
					font-variant-numeric: tabular-nums;
					letter-spacing: 0.5px;
				}
				&__unit { font-size: 13px; color: #E8A317; opacity: .85; }
				&__warn { margin-top: 8px; font-size: 12px; color: #9AA5B1; }
			}
			.mp-formula {
				background: #fff;
				border: 1px solid #D5D9DE;
				border-radius: 6px;
				padding: 12px 14px;

				&__title { display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
					code { font-size: 14px; font-weight: 600; color: #1B2430; }
				}
				&__badge {
					padding: 2px 8px; background: #E8F0F7; color: #2F5D8A;
					font-size: 11px; border-radius: 3px; font-weight: 600;
				}
				&__desc { font-size: 12px; color: #4A5562; margin-bottom: 8px; }
				&__list {
					margin: 0; padding-left: 16px; font-size: 12px; color: #6B7785; line-height: 1.7;
				}
			}
			.mp-friction-tip {
				display: flex; gap: 10px; align-items: flex-start;
				margin-bottom: 12px; padding: 10px 12px;
				background: #FFF8E8; border: 1px solid #F0D78C; border-radius: 4px;
				&__icon {
					flex-shrink: 0; width: 18px; height: 18px; border-radius: 50%;
					background: #E8A317; color: #fff; font-size: 11px; font-weight: 700;
					display: flex; align-items: center; justify-content: center;
				}
				p { margin: 0; font-size: 12px; color: #7A5A10; line-height: 1.65; }
			}
			.mp-friction-html {
				overflow-x: auto;
				table {
					width: 100%; border-collapse: collapse; border-spacing: 0;
					tbody tr {
						&:nth-child(1), &:nth-child(2) {
							background: #1B2430;
							td { color: #fff; font-weight: 600; border-color: #2A3444; }
						}
						&:nth-child(n+3):nth-child(odd) { background: #F7FAFC; }
						td {
							padding: 8px 10px; line-height: 20px; vertical-align: middle;
							border: 1px solid #E5E9EE; color: #1B2430; word-break: normal; font-size: 12px;
						}
					}
				}
			}

			.mp-as {
				flex: 1;
				background: #fff;
				border: 1px solid #D5D9DE;
				border-radius: 6px;
				padding: 12px 14px;
				display: flex;
				gap: 16px;
				align-items: center;
				min-height: 140px;

				&__sketch {
					width: 100px; height: 100px; flex-shrink: 0;
					border: 1px dashed #2F5D8A; border-radius: 4px;
					background: #F7FAFC;
					display: flex; align-items: center; justify-content: center;
				}
				&__chart-wrap { flex: 1; min-width: 0; }
				&__label { font-size: 12px; color: #6B7785; margin-bottom: 4px; }
				&__body { display: flex; align-items: center; gap: 16px; }
				&__chart { width: 100px; height: 100px; }
				&__meta {
					font-size: 12px; color: #4A5562; line-height: 1.7;
					span { color: #6B7785; margin-right: 8px; }
					strong { font-weight: 600; color: #1B2430; }
				}
				&__note { margin-top: 4px; color: #2F5D8A; font-size: 11px; }
			}

			.mp-empty {
				padding: 48px 16px;
				text-align: center;
				font-size: 14px;
				color: #6B7785;
			}

			.el-dialog__header {
				display: flex;
				align-items: center;
				font-weight: 600;
				box-sizing: border-box;
				height: 44px;
				background-color: #F6F6F6;
				border-bottom: 1px solid #DADADA;
				border-radius: 4px 4px 0px 0px;
				.el-dialog__headerbtn {
					top: 16px;
					right: 16px;
				}
				.el-dialog__title {
					font-size: 14px;
					margin-left: 16px;
				}
			}
			.el-dialog__body {
				padding: 16px 24px;
				background: transparent;
				border-bottom-left-radius: 4px;
				border-bottom-right-radius: 4px;
			}
			.el-dialog__headerbtn .el-dialog__close {
				color: #333333;
			}
		}
	}
</style>
